import SxDef from '@core/types/SxDef';

// Paper surface, radius and shadow come from the theme's MuiPopover pattern.
const useSx = (): SxDef => ({
  root: {
    // Header menus open just below the 64px navbar, whatever icon anchors them.
    '& .MuiMenu-paper': { top: '72px !important' },
    '& .MuiMenu-list': {
      minWidth: '14rem',
    },
  },
});

export default useSx;
